import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { v4 as SessionID } from 'uuid';
@Injectable({
  providedIn: 'root'
})
export class ContractconversionService {
  public _ContractconversionService = environment.ContractconversionService;
  public _httpOptions;
  public sessionId : string
  constructor(private http: HttpClient) { 
    this.sessionId = sessionStorage["SessionId"]
  this._httpOptions = {
    headers: new HttpHeaders({ 'SessionId':this.sessionId })
  };

  }

  GetPageInitializeDetails(): Observable<any>{
   

    var Query = this._ContractconversionService;
    // console.log(Query);
    return this.http.get<{ data: any }>(Query,this._httpOptions);
  }
  GetById(customersitecode:string): Observable<any>{
   

    var Query = this._ContractconversionService + '/GetById' +'/'+ customersitecode ;
    // console.log(Query);
    return this.http.get<{ data: any }>(Query,this._httpOptions);
  }
  
 
  InsertPrequoteContractConversion(coversion: object) {
    // console.log("Create");
    var Query = this._ContractconversionService;
    return this.http.post<{ data: any }>(Query, coversion,this._httpOptions);
  }
  UpdatePrequoteContractConversion(coversion: object) {
    // console.log("Create");
    // var Query = this._ContractconversionService;
    // return this.http.post<{ data: any }>(Query, coversion,this._httpOptions);

    // console.log("Update");
    var Query = this._ContractconversionService;
    // console.log(Query);
    return this.http.put<{ data: any }>(Query, coversion,this._httpOptions);
  }
}
